import { CartImpressionTrackingInfoItem } from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";
import { PageTemplate } from "@omni/types/enums/pageTemplate.enum";

import * as AlgoliaTrackingService from "@/services/algolia/algoliaTracking.service";
import * as AlgoliaUserService from "@/services/algolia/algoliaUser.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";
import { Config } from "@/utils/config.utils";
import { isPageTemplate } from "@/utils/pageTemplate.utils";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAddToCartPayload,
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaClickPayload
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsAddToCartImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaClickPayload> {}

const getAlgoliaAddToCartPayload = (
    eventData: CartImpressionTrackingInfoItem
): AlgoliaAddToCartPayload => {
    const lastQueryRecord = AlgoliaTrackingService.getLastQueryTrackRecordFor(
        eventData.id
    );

    const isPDP = isPageTemplate(PageTemplate.Pdp);

    return {
        authenticatedUserToken: AlgoliaUserService.getAuthenticatedUserToken(),
        eventName: isPDP
            ? AlgoliaAnalyticsEventNames.ProductAddToCartPDP
            : AlgoliaAnalyticsEventNames.ProductAddToCartPLP,
        index: Config.integrations["algolia-index-product"],
        userToken: AlgoliaUserService.getUserToken(),
        queryID: lastQueryRecord?.queryID,
        objectIDs: [eventData.id],
        currency: eventData.currencyCode || "EUR",
        objectData: [
            {
                price: eventData.price,
                quantity: eventData.quantity
            }
        ],
        value: Math.round(eventData.price * eventData.quantity * 100) / 100
    };
};

const getAlgoliaAnalyticsAddToCartImpression = (
    data: TypedAnalyticsEvent<CartImpressionTrackingInfoItem>
): Array<AlgoliaAnalyticsAddToCartImpression> => {
    const payload = getAlgoliaAddToCartPayload(data.payload.eventData);

    return [
        {
            eventName: payload.queryID
                ? AlgoliaAnalyticsEvents.ProductAddToCartAfterSearch
                : AlgoliaAnalyticsEvents.ProductAddToCartNoSearch,
            payload: payload
        }
    ];
};

export { getAlgoliaAnalyticsAddToCartImpression };
